<template>
    <basic-header
        pretitle="Adminstration"
        title="Entitlements"
        buttonText="Add Entitlement"
        @btnClick="showModal({ component: 'addEntitlement'})"
        :buttonRoles="addEntitlementRoles"
    />
    <div class="container-fluid">
        <div class="card">
            <Datatable
                tableId="entitlementTable"
                :columns="columns"
                uniqueField ="entitlement_id"
                :data="$store.state.admin.entitlements"
                @deleteRows="showDeleteEntitlements"
                :deletable="$store.getters.userRoles.isAqferAdmin"
                :compact="true"
                :selectCheckboxes="$store.getters.userRoles.isAqferAdmin"
                :detailColumn="{baseUrl:'entitlements/', name: 'Entitlement', identifier:'entitlement_id'}"
            />
        </div>
    </div>
</template>
<script>
import Datatable from '../../components/Datatable.vue';
import BasicHeader from '../../components/BasicHeader.vue';
import { mapActions } from 'vuex';
export default{
    name: "Entitlements",
    components:{ BasicHeader, Datatable},
    data(){
        return {
            columns:[
                { data: "name"},
                { data: "unit"},
                { data: "quantity"}
            ],
            addEntitlementRoles: [1]
        };
    },
    beforeMount(){
        this.$store.dispatch("admin/fetchEntitlements")
    },
    methods: {
        ...mapActions({
            showModal:"showModal"
        }),
        showDeleteEntitlements(rows){
            this.showModal({ component: "deleteEntitlements", data:rows });
        }
    }
}

</script>
<style></style>